import { render, staticRenderFns } from "./ComplaintsSamplesFilter.vue?vue&type=template&id=e6947976"
import script from "./ComplaintsSamplesFilter.vue?vue&type=script&lang=js"
export * from "./ComplaintsSamplesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports